// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__35E0h","amount":"Amount_amount__2DIKW","tip":"Amount_tip__3WFXL","tipHeader":"Amount_tipHeader__2xA2W","tipsWrap":"Amount_tipsWrap__XckZE"};